import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-line bg-white px-6 py-8 md:px-12">
      <div className="mx-auto flex max-w-content flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-ink-faint">
          &copy; {new Date().getFullYear()} James Carl-Rhule &middot; Public Sector Leadership &amp; Organisational Development
        </p>
        <div className="flex flex-wrap gap-x-6 gap-y-2 text-[0.7rem] uppercase tracking-widest2 text-ink-soft">
          <Link to="/" className="hover:text-teal-900">Home</Link>
          <Link to="/initiatives" className="hover:text-teal-900">Experience</Link>
          <Link to="/gallery" className="hover:text-teal-900">Gallery</Link>
        </div>
      </div>
    </footer>
  );
}
